export default "__VITE_ASSET__pgMJK3k3__"